import { ResourcesConfig } from 'aws-amplify';

export const awsConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: 'us-east-1_y4C9YDoa5',
      userPoolClientId: '6m9pn1kmh9t9fn40ce04ur2o18',
      identityPoolId: 'us-east-1:9d356080-b763-48ca-bfe0-25ccd721003f',
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
      },
    },
  },
};

export const s3Config = {
  primaryDataBucket: 'bigsplice-us-east-1',
  frontendHostingBucket: 'bigsplice-frontend-hosting',
  configBucket: 'bigsplice-config',
};

const G = 'https://jtbb58634f.execute-api.us-east-1.amazonaws.com/prod';
const H = 'https://81uo5stx4l.execute-api.us-east-1.amazonaws.com/prod';

export const lambdaEndpoints = {
  ingest: 'https://8ubap2dd99.execute-api.us-east-1.amazonaws.com/prod/upload',
  analysis: `${G}/analyze-rg`,
  chunkAnalysis: `${G}/analyze-chunks`,
  largeUpload: `${G}/large-upload`,
  fileList: `${G}/files`,
  fileDelete: 'https://bmrhfdz9sd.execute-api.us-east-1.amazonaws.com/prod/delete',
  fileUpload: `${G}/upload`,
  fileMove: `${H}/files/organize`,
  queryGenerator: 'https://6e91swgb1m.execute-api.us-east-1.amazonaws.com/prod/generate-query',
  queryGeneratorClaude: 'https://y2guidyqe7.execute-api.us-east-1.amazonaws.com/prod/generate-query',
  queryGeneratorBedrock: 'https://khi9ez38fi.execute-api.us-east-1.amazonaws.com/prod/generate-query',
  queryHistory: 'https://3jiu4hr9n1.execute-api.us-east-1.amazonaws.com/prod/history',
  queryCache: '',
  queryResults: 'https://rarrjeqbqb.execute-api.us-east-1.amazonaws.com/query-results',
  presignedUrlGenerator: 'https://g9jgt4mszf.execute-api.us-east-1.amazonaws.com/prod/presigned-url',
  mcpKeyManager: 'https://3vtxzalyz6.execute-api.us-east-1.amazonaws.com/prod/mcp-key',
  processingStatus: 'https://rs4ogchpo9.execute-api.us-east-1.amazonaws.com/prod/status',
  urlDownloader: 'https://kx1xqgr877.execute-api.us-east-1.amazonaws.com/prod/download',
  urlDownloadProgress: 'https://kx1xqgr877.execute-api.us-east-1.amazonaws.com/prod/progress',
  s3Credentials: `${H}/s3-credentials`,
  s3FileBrowser: `${H}/s3-files`,
  s3Transfer: `${H}/s3-transfer`,
  usageApi: 'https://u1d04cc8rd.execute-api.us-east-1.amazonaws.com/prod',
  adminApi: 'https://84azebpw4i.execute-api.us-east-1.amazonaws.com/prod',
  sqlConnections: `${H}/sql-connections`,
  sqlTest: `${H}/sql-test`,
  sqlJobs: `${H}/sql-jobs`,
  sqlIntrospect: `${H}/sql-introspect`,
  introspect: 'https://we81y3iake.execute-api.us-east-1.amazonaws.com/prod/introspect',
  integrationRequest: `${G}/integration-request`,
  multiFileQuery: `${G}/multi-query`,
  accessControlApi: 'https://43f6t8k2p1.execute-api.us-east-1.amazonaws.com/prod',
  chatOrchestrator: `${G}/chat`,
  sheets: `${G}/sheets`,
  sheetsS3: `${G}/sheets-s3`,
  sheetsSearch: `${G}/search`,
  searchOrchestrator: `${G}/tantivy`,
  gcpCredentials: `${H}/gcp-credentials`,
  gcpFileBrowser: `${H}/gcp-files`,
  gcpTransfer: `${H}/gcp-transfer`,
  dataSources: `${H}/data-sources`,
  flows: `${H}/flows`,
  aiColumnInference: `${H}/ai-column`,
};

export const cloudFrontConfig = {
  distributionId: 'E3VSXWT6NAZ99X',
};
